import { render, staticRenderFns } from "./handlewarning.vue?vue&type=template&id=c7450c94&"
import script from "./handlewarning.vue?vue&type=script&lang=ts&"
export * from "./handlewarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports